import { useEffect } from 'react';
export function useCustomValidity(ref, customValidity) {
  useEffect(function () {
    if (ref.current) {
      ref.current.setCustomValidity(customValidity || '');
    }
  }, [customValidity, ref]);
}